import { createAction } from 'redux-action';

export const TOGGLE_MENU = 'TOGGLE_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';

export const toggleMenu = createAction(TOGGLE_MENU);
export const closeMenu = createAction(CLOSE_MENU);
